import { useState, useEffect, Fragment, useRef } from 'react';

import './wallboard-table.css';

import {
    Table,
} from '../../../components/components';

import { useInterval } from '../../../interval';
import { calcDuration, calcPercent } from '../puzzel-queue';
import { loadWallboardQueues } from '../wallboards';

function transformQueueToViewData(queue) {
    queue.callsAnsweredWithinSla = queue.callsOfferedToday === 0 ? 100 : calcPercent(queue.callsAnsweredWithinSla, queue.callsOfferedToday);
    return queue;
}

function useWallboardQueues(refresh, customerKeys) {
    const [queues, setQueues] = useState([]);
    const [tokens, setTokens] = useState({});

    const load = useRef(async () => {
        const queues = await loadWallboardQueues(customerKeys, tokens, setTokens);
        const parsedQueues = queues.map(queue => transformQueueToViewData(queue));
        setQueues(parsedQueues);
    });

    useInterval(() => {
        load.current();
    }, refresh * 1000);

    useEffect(() => {
        load.current();
    }, []);

    return queues;
}

export function TableWallboard({ wallboard, refresh }) {
    const queues = useWallboardQueues(refresh, wallboard.customerKeys);

    return (
        <Table class="wallboard-table">
            <thead>
                <tr>
                    {wallboard.tableColumns.map((column, index) =>
                        <th key={index}>
                            {column.name || column.property}
                        </th>
                    )}
                </tr>
            </thead>
            <tbody>
                {queues.map((queue, index) =>
                    <QueueRow key={index} columns={wallboard.tableColumns} queue={queue} />
                )}
            </tbody>
        </Table>
    );
}

function QueueRow({queue, columns}) {
    const className = queue.queueSize > queue.queueSizePreferred ? "highlight-row" : "";

    return (
        <tr className={className}>
            {columns.map((column, index) =>
                <Fragment key={index}>
                    {column.type === "Percent" &&
                        <td>{queue[column.property]}%</td>
                    }
                    {column.type === "Duration" &&
                        <td>{calcDuration(queue[column.property])}</td>
                    }
                    {column.type === "Text" &&
                        <td>{queue[column.property]}</td>
                    }
                </Fragment>
            )}
        </tr>
    );
}